/**
 * @module constants/pricing
 * @description Pay-per-use and subscription plan definitions for home checkout.
 * @extracted-from client/src/components/Paywall.js
 */

/** Pay-per-use: $1 per analysis credit (quantity selectable at checkout). */
export const PRICING_TIERS = [
  {
    id: 'pay_per_use',
    name: 'Pay per use',
    quantity: 1,
    price: 1.0,
    originalPrice: 1.0,
    discount: 0,
    popular: false,
    subtitle: 'Pay as you go — stack credits and use them anytime.',
    description:
      '$1 USD per credit. Choose how many you want below; each credit runs one full analysis for music or books. Checkout is secure through Stripe.',
  },
];

/** Monthly subscription tiers (Stripe billing interval comes from each Price). */
export const SUBSCRIPTION_PLANS = [
  { id: '50', name: 'Starter', price: 10, analyses: 50, description: '50 analyses per billing period' },
  { id: '200', name: 'Pro', price: 20, analyses: 200, popular: true, description: '200 analyses per billing period' },
  { id: '500', name: 'Studio', price: 50, analyses: 500, description: '500 analyses per billing period' },
];
